/* eslint-disable no-unused-vars */
const Autodesk = window.Autodesk;
import { removeFromScene, setForgeCropBox } from '../utils/forgeUtils'
import { drawRectangle2D, drawPoint2D } from '../utils/threejsUtils'
import { getMarkupsComponent } from '../scripts/js/forgeviewer'
const THREE = window.THREE;

export class Cropping2DExtension extends Autodesk.Viewing.Extension {
    constructor(loadedViewer, options) {
        super(loadedViewer, options);
        this.viewer = loadedViewer;
        this.webGLDOM = this.viewer.canvas.parentElement.parentElement.parentElement;
        this.isActive = false;
        let _this = this;
        this.webGLDOM.addEventListener("click", (event) => {
            _this.onMouseUp(event);
        });
        this.viewer.canvas.addEventListener("mousedown", (event) => {
            _this.onMouseDown(event);
        });
        this.webGLDOM.addEventListener("mousemove", (event) => {
            _this.onMouseMove(event);
        }, false);
        this.sceneName = 'crop2d-scene';
        this.cropBoxColor = 0x0000ff;
        this.pointsColor = 0x000000;

        this.cropBox = null;
        this.cropBoxMesh = null;
        this.cropBoxPoints = [];

        this.draggingPoint = null;
        this.highlightingPoint = null;

        this.croppingOn = false;
        this.pointTypes = {
            BottomLeft: 'BottomLeft',
            BottomRight: 'BottomRight',
            TopRight: 'TopRight',
            TopLeft: 'TopLeft',
            Left: 'Left',
            Right: 'Right',
            Top: 'Top',
            Bottom: 'Bottom',
        }

    }

    load() {
        return true;
    }
    unload() {
        return true;
    }
    onToolbarCreated() {
    }

    setCropping(box, enable) {
        this.croppingOn = enable;
        removeFromScene(this.cropBoxMesh, this.viewer, this.sceneName);
        removeFromScene(this.cropBoxPoints.map(o => o.mesh), this.viewer, this.sceneName);
        if (this.croppingOn) {
            let bBox = box ? box : this.viewer.model.getBoundingBox();
            this.setCropBoxAndControls(bBox);
        }
        this.viewer.impl.invalidate(true, true, true);
    }
    setCropBoxAndControls(bBox) {
        this.cropBoxMesh = drawRectangle2D(bBox.min, bBox.max, this.cropBoxColor, this.viewer, this.sceneName);
        let center = bBox.getCenter();
        this.cropBoxPoints = [
            { type: this.pointTypes.BottomLeft, point: bBox.min },
            { type: this.pointTypes.BottomRight, point: new THREE.Vector3(bBox.max.x, bBox.min.y) },
            { type: this.pointTypes.TopRight, point: bBox.max },
            { type: this.pointTypes.TopLeft, point: new THREE.Vector3(bBox.min.x, bBox.max.y) },
            { type: this.pointTypes.Left, point: new THREE.Vector3(bBox.min.x, center.y) },
            { type: this.pointTypes.Right, point: new THREE.Vector3(bBox.max.x, center.y) },
            { type: this.pointTypes.Top, point: new THREE.Vector3(center.x, bBox.max.y) },
            { type: this.pointTypes.Bottom, point: new THREE.Vector3(center.x, bBox.min.y) },
        ];
        this.cropBoxPoints.forEach(o => o.mesh = drawPoint2D(o.point, this.pointsColor, this.viewer, this.sceneName));
        this.setCropBox(bBox);
        this.viewer.impl.invalidate(true, true, true);
    }
    setCropBox(box) {
        this.cropBox = box;
        if (!box || !box.min || box.max)
            return;
        setForgeCropBox(box, this.viewer);
    }
    clearHighlightingPoint() {
        if (this.highlightingPoint) {
            removeFromScene(this.highlightingPoint, this.viewer, this.sceneName);
            this.highlightingPoint = null;
            this.viewer.impl.invalidate(true, true, true);
        }
    }

    onMouseMove(mouse) {
        this.clearHighlightingPoint();
        if (!this.croppingOn || !this.viewer.impl)
            return;
        let mouseWorld = this.viewer.clientToWorld(mouse.offsetX, mouse.offsetY, true, true);
        if (!mouseWorld)
            return;
        mouseWorld = mouseWorld.point;

        if (!this.draggingPoint) {
            //highlight point
            let pointUnderMouse = this.cropBoxPoints.find(o => o.point.distanceTo(mouseWorld) < 0.02);
            if (pointUnderMouse)
                this.highlightingPoint = drawPoint2D(pointUnderMouse.point, 0xff0000, this.viewer, this.sceneName);
        } else {
            let oldMin = this.cropBoxPoints.find(o => o.type == this.pointTypes.BottomLeft).point;
            let oldMax = this.cropBoxPoints.find(o => o.type == this.pointTypes.TopRight).point;
            let newBox = null;
            let min, max;
            switch (this.draggingPoint.type) {
                case 'BottomLeft':
                    newBox = new THREE.Box3(mouseWorld, oldMax)
                    break;
                case 'BottomRight':
                    min = new THREE.Vector3(oldMin.x, mouseWorld.y);
                    max = new THREE.Vector3(mouseWorld.x, oldMax.y);
                    newBox = new THREE.Box3(min, max);
                    break;
                case 'TopRight':
                    newBox = new THREE.Box3(oldMin, mouseWorld);
                    break;
                case 'TopLeft':
                    min = new THREE.Vector3(mouseWorld.x, oldMin.y);
                    max = new THREE.Vector3(oldMax.x, mouseWorld.y);
                    newBox = new THREE.Box3(min, max);
                    break;
                case 'Left':
                    min = new THREE.Vector3(mouseWorld.x, oldMin.y);
                    newBox = new THREE.Box3(min, oldMax);
                    break;
                case 'Right':
                    max = new THREE.Vector3(mouseWorld.x, oldMax.y);
                    newBox = new THREE.Box3(oldMin, max);
                    break;
                case 'Top':
                    max = new THREE.Vector3(oldMax.x, mouseWorld.y);
                    newBox = new THREE.Box3(oldMin, max);
                    break;
                case 'Bottom':
                    min = new THREE.Vector3(oldMin.x, mouseWorld.y);
                    newBox = new THREE.Box3(min, oldMax);
                    break;
            }
            if (newBox.min.x > newBox.max.x || newBox.min.y > newBox.max.y)
                return;
            removeFromScene(this.cropBoxMesh, this.viewer, this.sceneName);
            removeFromScene(this.cropBoxPoints.map(o => o.mesh), this.viewer, this.sceneName);

            //save current crop box so when you switch on/off crop button it will show saved data
            if (getMarkupsComponent()) {
                getMarkupsComponent().currentCropBox = newBox;
            }
            this.setCropBoxAndControls(newBox);
        }

    }
    onMouseDown(mouse) {
        if (mouse.which != 1 || !this.croppingOn)
            return;
        let mouseWorld = this.viewer.clientToWorld(mouse.offsetX, mouse.offsetY, true, true);
        if (!mouseWorld)
            return;
        mouseWorld = mouseWorld.point;

        //lock view
        let settings = this.viewer.navigation.getLockSettings();
        settings.zoom = false;
        settings.pan = false;
        this.viewer.navigation.setLockSettings(settings);
        this.viewer.navigation.setIsLocked(true);

        this.draggingPoint = this.cropBoxPoints.find(o => o.point.distanceTo(mouseWorld) < 0.02);
    }
    onMouseUp(mouse) {
        if (mouse.which != 1 || !this.croppingOn)
            return;
        this.clearHighlightingPoint();
        this.draggingPoint = null;
        this.viewer.navigation.setIsLocked(false);
    }

}
Autodesk.Viewing.theExtensionManager.registerExtension('Cropping2DExtension', Cropping2DExtension);
